import PropTypes from 'prop-types';
import React from 'react';
import { useUser } from '../../User/containers/UserDataStore';
import { useComments } from '../containers/commentsDataStore';
import ConversationStatus from '../ConversationStatus';
import CommentAttribution from '../UI/CommentAttribution';
import Badges from './Badges';
import BadgeActions from './BadgesActions';
import CommentInputFrame from './CommentInputFrame';
import ParsedComment from './ParsedComment/ParsedComment.js';

Comment.propTypes = {
	comment: PropTypes.object,
};

Comment.defaultProps = {
	comment: {},
};

export default function Comment({ comment }) {
	const [isInEditMode, setIsInEditMode] = React.useState(false);

	const commentsDataStore = useComments();

	const userDataStore = useUser();
	const { user } = userDataStore.state.user;

	const renderDeletedMessage = comment => {
		const isOwner = user && user.id === comment.appUserId;
		return (
			<div style={{ marginTop: '6px' }}>
				<span className="italic">
					This message has been deleted{' '}
					{isOwner ? 'by you.' : 'by the user.'}
				</span>
				{isOwner && (
					<span
						className="acc-font pad-left-10 clickable"
						onClick={() => toggleDeleteNote(comment.id)}>
						Undo
					</span>
				)}
			</div>
		);
	};

	const renderActiveMessage = comment => {
		return (
			<React.Fragment>
				<CommentAttribution comment={comment} />
				<div className="clear">
					{!isInEditMode ? (
						<ParsedComment commentText={comment.text} />
					) : (
						<CommentInputFrame
							comment={comment}
							toggleEditMode={toggleEditMode}
							isEditingExistingNote={true}
						/>
					)}
				</div>
				{comment.badges && comment.badges.length > 0 && (
					<div className="badges">
						<Badges
							badges={comment.badges}
							commentId={comment.id}
						/>
					</div>
				)}
				<BadgeActions
					comment={comment}
					toggleEditMode={toggleEditMode}
				/>
			</React.Fragment>
		);
	};

	const toggleDeleteNote = commentId => {
		commentsDataStore.changeCommentStatus(commentId, 0);
	};

	const toggleEditMode = () => {
		setIsInEditMode(!isInEditMode);
	};

	return (
		<div className="relative comment-card">
			{comment.commentStatus === ConversationStatus.deleted ? (
				<React.Fragment>{renderDeletedMessage(comment)}</React.Fragment>
			) : (
				<React.Fragment>{renderActiveMessage(comment)}</React.Fragment>
			)}
		</div>
	);
}
